import { useEffect, useState } from "react";
import { frequent, nojoin } from "../../services/Mainservice";
import { useNavigate } from "react-router-dom";
import { EyeIcon } from "lucide-react";
import Loader from "../../Loader/Loader";

const Behaviour = () => {
  const [frq, setfrq] = useState();
  const [click, setclick] = useState();
  const [loading, setloading] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getlist();
  }, []);

  const getlist = async () => {
    try {
      setloading(true);
      const data = await frequent();
      const data2 = await nojoin();
      setloading(false);
      setfrq(data.data.data);
      setclick(data2.data.data);
    } catch {}
  };

  return (
    <>
      <div className="behaviour">
        <div className="user_behaviour">
          <div className="user_behaviour_content">
            <div className="data_head">
              <h1 className="data_heading">Frequent Joiner</h1>
            </div>

            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>User Image</th>
                    <th>Name</th>
                    <th>Joining Time</th>
                  </tr>
                </thead>
                <tbody>
                  {frq?.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <img
                          src={item.image}
                          alt="profile"
                          className="table_img"
                        />
                      </td>
                      <td>{item.firstName}</td>
                      <td>{item.totalJoins}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="user_behaviour_content">
            <div className="data_head">
              <h1 className="data_heading">Click but not joined</h1>
            </div>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Name</th>
                    <th>Click</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {click?.map((item) => (
                    <tr key={item.id}>
                      <td>{item.Title}</td>
                      <td>{item.FirstName}</td>
                      <td>{item.clickCount}</td>
                      <td>
                        {" "}
                        <div className="user_actionicon">
                          <EyeIcon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate("/Post_Details", {
                                state: {
                                  id: item.postId,
                                },
                              })
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </>
  );
};
export default Behaviour;
